<h2 mat-dialog-title>PDF Datei zu komplex</h2>
<mat-dialog-content>Solle die PDF Datei bearbeitbar gemacht werden?</mat-dialog-content>
<mat-dialog-actions align="end">
    <button app-button Color="red" [mat-dialog-close]="false" >Nein</button>
    &nbsp;
    <button app-button Color="green"  [mat-dialog-close]="true" >Ja</button>
</mat-dialog-actions>
